import React from 'react';
import Head from 'next/head';
import { ClaytonEmployeeCANoticeStyles } from '@components/LegalPrivacy/Privacy/ClaytonEmployeeCANoticeCollection.styled';
import { ClaytonEmployeeCACollectionContent } from '@components/LegalPrivacy/Privacy/ClaytonEmployeeCANoticeCollectionContent';

const Financial = () => {
  return (
    <ClaytonEmployeeCANoticeStyles>
      <Head>
        <title>CA Employee Privacy Policy | Clayton Homes</title>
        <meta
          name="description"
          content="We respect your privacy and are committed to providing a transparent notice of our Privacy Notice."
        />
      </Head>
      <ClaytonEmployeeCACollectionContent />
    </ClaytonEmployeeCANoticeStyles>
  );
};

export default Financial;
